import type { Component, Snippet } from "svelte";
import type { LayoutName } from "$lib/elev8Api/contentTypes";

interface LayoutProps {
  logoUrl?: string;
  fullBleedLogo?: boolean;
  visionEnabled?: boolean;
  ContentMain?: Snippet;
  ContentSecondary?: Snippet;
  ContentTertiary?: Snippet;
  ContentWeather?: Snippet;
  children?: Snippet;
  // children?: Snippet;
  // ContentMain?: Component;
  // ContentWeather?: Component;
  // ContentSide?: Component;
}
interface LayoutComponent extends Component<LayoutProps> {}

const COLOR_KEYS = [
  "white",
  "black",
  "primary",
  "secondary",
  "accent",
  "neutral",
  "neutralDark",
  "neutralLight",
] as const;

interface LayoutTheme {
  white: string;
  black: string;
  primary: string;
  secondary: string;
  accent: string;
  neutral: string;
  neutralDark: string;
  neutralLight: string;
  fontH1: string;
  fontH2: string;
  fontBody: string;
  fontButton: string;
  fontWeightH1: string;
  fontWeightH2: string;
  fontWeightBody: string;
  fontWeightButton: string;
  fontStyleH1: string;
  fontStyleH2: string;
  fontStyleBody: string;
  fontStyleButton: string;
  fontSizeBase: string;
}

/** Alpha opacity values for color variants (decimal for rgba() compatibility with older browsers) */
const COLOR_ALPHAS = {
  "80": 0.8,
  "50": 0.5,
  "30": 0.3,
  "20": 0.2,
  "10": 0.1,
} as const;

export { COLOR_ALPHAS, COLOR_KEYS };
export type { LayoutComponent, LayoutProps, LayoutTheme, LayoutName };
